import { Outlet } from 'react-router-dom'

export function App() {
  return (
    <>
      <Outlet />
    </>
  )
}
